import {useState} from 'react';

const defaultValidator = value => !value?.length;
export const useInput = (initialValue = '', validator) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState(false);

  const handleChange = e => {
    setValue(e.target.value);
    validate(e.target.value);
  };

  const validate = value => {
    if (validator) {
      return validator(value);
    } else {
      setError(defaultValidator(value));
      return defaultValidator(value);
    }
  };

  return {
    value,
    handleChange,
    error,
    validate,
  };
};
